<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="48" height="48" rx="8" fill="#F3EFFA"/>
<rect x="12" y="6" width="20" height="36" rx="4" fill="url(#paint0_linear_1555_9124)"/>
<circle cx="22" cy="38" r="1.5" stroke="#CABEFF"/>
<path d="M19 9C19 8.44772 19.4477 8 20 8H24C24.5523 8 25 8.44772 25 9C25 9.55228 24.5523 10 24 10H20C19.4477 10 19 9.55228 19 9Z" fill="#302F38"/>
<path opacity="0.64" d="M42 24C42 25.5327 36.6274 31 30 31C23.3726 31 18 25.5327 18 24C18 22.4673 23.3726 17 30 17C31.3242 17 32.5983 17.2183 33.7895 17.5798C34.9482 17.9315 36.0285 18.4188 37 18.9726C40.0281 20.6988 42 23.0715 42 24Z" fill="#FAABFF"/>
<circle cx="30" cy="24" r="4" fill="#302F38"/>
<circle cx="33" cy="24" r="2" fill="#F07EFF"/>
<rect x="30" y="11" width="1" height="4" rx="0.5" fill="#FFFBF7"/>
<rect x="36.5605" y="12.2324" width="1" height="4" rx="0.5" transform="rotate(45 36.5605 12.2324)" fill="#F07EFF"/>
<rect width="1" height="4" rx="0.5" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 26.5605 15.7681)" fill="#FFFBF7"/>
<defs>
<linearGradient id="paint0_linear_1555_9124" x1="15.4375" y1="37.125" x2="36.7316" y2="24.4696" gradientUnits="userSpaceOnUse">
<stop stop-color="#5D34F2"/>
<stop offset="1" stop-color="#FAABFF"/>
</linearGradient>
</defs>
</svg>
